import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M14.25 11.25h.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-3.1c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-.8m0 9.5h-.043c-.433 0-.649 0-.83.074a1 1 0 0 0-.409.308c-.121.155-.18.363-.3.778l-1.461 5.116a.998.998 0 0 1-.96.724 1.997 1.997 0 0 1-1.997-1.997V13.85c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H5.32c-1.44 0-2.156 0-2.64-.3a2.015 2.015 0 0 1-.88-1.154c-.155-.548.054-1.24.45-2.625l1.17-4.1c.238-.832.357-1.248.6-1.557a1.98 1.98 0 0 1 .81-.616c.364-.148.795-.148 1.66-.148h7.76m0 9.5v-9.5"
	})]
});
const ForwardRef = forwardRef(SvgThumbDown);
export { ForwardRef as ReactComponent };
